export default __webpack_public_path__ + "static/media/Playlist-Thumbnail.c4ef0d2f.png";